export enum FileType {
	Pdf,
}
